import { createSlice } from '@reduxjs/toolkit';

const initialFormData = {
  cm_id: '',
  cm_date: '',
  cm_ispost: 0,
  cm_description: '',
  equip_id1: '',
  cmdetil1_rjo: '',
  province_id1: '0',
  regency_id1: '0',
  district_id1: '0',
  village_id1: '0',
  equip_fulladdress1: '',
  equip_status1: '',
  equip_id2: '',
  equip_status2: '',
  province_id2: 0,
  regency_id2: 0,
  district_id2: 0,
  village_id2: 0,
  equip_fulladdress2: '',
  cm_createdby: '',
  cm_createddate: '',
  cm_modifyby: '',
  cm_modifydate: '',
  rowid: '',
};

const initialState = {
  formData: initialFormData,
  dataList: [],
  totalData: 0,
  loading: false,
  loadingMessage: '',
  error: null,
  activeTab: 0,
};

const ops07cmSlice = createSlice({
  name: 'ops07cm',
  initialState,
  reducers: {
    setActiveTab: (state, action) => { state.activeTab = action.payload; },
    setDataList: (state, action) => { state.dataList = action.payload; },
    setTotalData: (state, action) => { state.totalData = action.payload; },
    setLoading: (state, action) => { state.loading = action.payload; },
    setLoadingMessage: (state, action) => { state.loadingMessage = action.payload; },
    setErrorMsg: (state, action) => { state.error = action.payload; },
    updateFormData: (state, action) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    clearFormData: (state) => {
      state.formData = initialFormData;
    },
    fetchDetailSuccess: (state, action) => {
      state.formData = { ...initialFormData, ...action.payload };
      state.loading = false;
      state.error = null;
    },
    fetchDetailFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchDetailError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearModuleState: (state) => {
      state.formData = initialFormData;
      state.dataList = [];
      state.totalData = 0;
      state.loading = false;
      state.loadingMessage = '';
      state.error = null;
      state.activeTab = 0;
    },
  },
});

export const {
  setActiveTab,
  setDataList,
  setTotalData,
  setLoading,
  setLoadingMessage,
  setErrorMsg,
  updateFormData,
  clearFormData,
  fetchDetailSuccess,
  fetchDetailFailure,
  fetchDetailError,
  clearModuleState,
} = ops07cmSlice.actions;

export { initialFormData as initialOps07CmFormData };
export default ops07cmSlice.reducer;
